import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  item: {
    border: `1px solid ${palette.divider}`,
    borderRadius: spacing(1),
    cursor: "pointer",
    height: spacing(3),
    marginRight: spacing(1),
    width: spacing(3),
  },
}));
